import styled from 'styled-components';
import { Text14Regular } from '../../Text/Text.styles';
import { theme } from '../../../../styles/constants';

export const LabelText = styled(Text14Regular)`
  margin-bottom: 0.6rem;
  margin-left: 0.2rem;
  text-transform: capitalize;
`;

export const PhoneInputWrapper = styled.div`
  .special-label {
    background-color: transparent;
    color: ${theme.colors.textColor};
    font-size: 1.4rem;

    position: relative;
    left: 0;
    top: 0;
    width: fit-content;
    margin-bottom: 0.6rem;
    margin-left: 0.2rem;
    padding: unset;
  }

  .react-tel-input {
    font-family: inherit;
    height: 7.2rem;
  }

  .flag-dropdown {
    height: 4.8rem;
    top: -4.8rem;
    position: relative;
    width: 5.2rem;

    &.open {
      width: 100%;
    }
  }

  .selected-flag {
    &.open {
      width: 100%;
    }
  }

  .country-list {
    background-color: ${theme.colors.white};
    color: ${theme.colors.textColor};
    border-radius: 16px;
    border: 1px solid #97c9f1;
    width: 100%;
    box-shadow: none;
  }

  .dial-code {
    color: ${theme.colors.textColor} !important;
  }

  .country {
    &.highlight {
      background-color: ${theme.colors.white} !important;
    }

    :hover {
      background-color: ${theme.colors.white} !important;
    }
  }

  .form-control {
    outline: none;
    font-size: 1.5rem;
    letter-spacing: -0.15px;
    line-height: normal;
    font-weight: 400;
    color: ${theme.colors.textColor};
    width: 100%;
    height: 4.8rem;
    border-radius: 16px;
    border: 1px solid #97c9f1;
    outline: none;
    box-shadow: none;
    background: ${theme.colors.white};

    &::placeholder {
      color: #0b3a5f;
      font-weight: 300;
    }

    &:hover {
      border: 1px solid #97c9f1;
      box-shadow: none;
    }

    &:focus {
      box-shadow: none;
      border: 1px solid #97c9f1;
    }
  }
`;
